import { apiGateway } from '@va/api-client';
import { AUTHENTICATE, authenticateFailed, authenticateSucceeded } from '@va/dashboard/actions/api';
import { setInstanceId } from '@va/dashboard/actions/app';
import { aiApiClient } from '@va/dashboard/shared/ai-assistant';
import { appHistory } from '@va/shared/router';
import { storageItems } from '@va/standalone/shared/constants';
import { getPlatformName, LocalStorage } from '@va/util/helpers';
import flagsmith from 'flagsmith';
import moment from 'moment';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import Api from 'wix/apiClient';

export function* watchers() {
  yield all([takeLatest(AUTHENTICATE, authenticate)]);
}

function* authenticate(action) {
  try {
    const data = yield call(Api.authenticate, action.instance);
    // TODO: validate data
    const now = moment().unix();
    const credentials = {
      token: data.token,
      refreshToken: data.refreshToken,
      impersonateToken: null,
      //auth token is valid for an hour
      tokenExpiry: now + 3600,
      //refresh token is valid for 24 hours
      refreshTokenExpiry: now + 86400,
      instanceId: data.id,
    };

    flagsmith.identify(data.id, { platform: getPlatformName() });
    LocalStorage.setItem(storageItems.loginToken, credentials.token);
    LocalStorage.setItem(storageItems.refreshToken, credentials.refreshToken);
    LocalStorage.setItem(storageItems.refreshTokenExpiry, credentials.refreshTokenExpiry);
    LocalStorage.setItem(storageItems.loginTokenExpiry, credentials.tokenExpiry);

    apiGateway.setAuthToken(credentials.token);
    aiApiClient.setAuthToken(credentials.token);

    yield put(setInstanceId(data.id));
    yield put(authenticateSucceeded(credentials));
  } catch (error) {
    yield put(authenticateFailed(error));

    const pushTo = appHistory.location.pathname === '/impersonate' ? '/generate-impersonate' : '/error';
    appHistory.push(pushTo);
  }
}
